import { NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-svg-templates',
  imports: [NgSwitchCase, NgSwitch],
  templateUrl: './svg-templates.component.html',
  styleUrl: './svg-templates.component.css',
  standalone: true
})
export class SvgTemplatesComponent {
@Input() svgType: string = '';
}
